// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"d89ac4ab","18":"2475107f","230":"3ee688aa","819":"c5911590","887":"ca6b81e2"}[chunkId] + ".chunk.css";
};